export default "__VITE_ASSET__D29cUNHp__"